import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Card,
  CardContent,
  DialogActions,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import { useStyles, Button } from './styles';

const ViewResult = (props) => {
  const {
    openResult, onCloseResult, result, fetchUrl,
  } = props;
  const classes = useStyles();

  return (
    <Dialog open={openResult} onClose={onCloseResult} fullWidth maxWidth="sm">
      <DialogContent className={classes.cardContent}>
        <Box className={classes.mainBoxes}>
          <Box>
            <Card className={classes.leftCards}>
              <CardContent>
                <Typography className={classes.title}>Resultado</Typography>
                <Typography className={classes.texts}>
                  {result.resultado}
                </Typography>
              </CardContent>
            </Card>
            {result.adjuntos?.length > 0 ? (
              <Card className={classes.leftCards}>
                <CardContent>
                  <Typography className={classes.title}>Archivos</Typography>
                  <CardContent className={classes.contentRFiles}>
                    {result.adjuntos?.map((adjunto) => (
                      <Box key={adjunto.id} className={classes.containerRFiles}>
                        <Typography className={classes.textRFiles}>
                          {adjunto.nombre_adjunto}
                        </Typography>
                        <IconButton
                          className={classes.iconButton}
                          onClick={() => fetchUrl(adjunto?.urlFirmada)}
                        >
                          <Tooltip title="Ver archivo">
                            <Visibility fontSize="small" />
                          </Tooltip>
                        </IconButton>
                      </Box>
                    ))}
                  </CardContent>
                </CardContent>
              </Card>
            ) : null}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseResult} width="fullWidth">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewResult;
